// Mock data for Pranav's 3D Portfolio Website

export const personalInfo = {
  name: "Pranav Kumar",
  title: "Full-Stack Developer & Digital Marketing Specialist",
  email: "pranavkumar431@gmail.com",
  phone: "+917004961989",
  location: "India",
  bio: "Passionate developer and digital marketing expert with expertise in creating stunning web experiences and driving online growth through strategic social media marketing.",
  avatar: "/api/placeholder/150/150",
};

export const services = [
  {
    id: 1,
    title: "Web Development",
    description:
      "Custom websites, e-commerce platforms, and web applications built with modern technologies",
    icon: "code",
    features: ["React & Next.js", "E-commerce Solutions", "API Integration", "Responsive Design"],
    color: "blue",
  },
  {
    id: 2,
    title: "Social Media Marketing",
    description:
      "Comprehensive digital marketing strategies to boost your online presence and engagement",
    icon: "megaphone",
    features: [
      "Content Strategy",
      "Social Media Management",
      "Paid Advertising",
      "Analytics & Reporting",
    ],
    color: "green",
  },
  {
    id: 3,
    title: "Digital Strategy",
    description:
      "Complete digital transformation solutions combining development and marketing expertise",
    icon: "target",
    features: ["Business Analysis", "Growth Hacking", "Conversion Optimization", "Brand Development"],
    color: "purple",
  },
];

export const projects = [
  {
    id: 1,
    title: "Petelvara - Flower E-commerce",
    description:
      "A complete e-commerce platform for flower and plant delivery with category management, shopping cart, and payment integration.",
    image: "/api/placeholder/600/400",
    url: "https://petalvara.com/",
    github: "#",
    technologies: ["WordPress", "WooCommerce", "PHP", "JavaScript", "CSS"],
    category: "web-development",
    featured: true,
    metrics: {
      performance: "95%",
      sales: "+150%",
      users: "2K+",
    },
  },
  {
    id: 2,
    title: "TechStartup Landing Page",
    description:
      "Modern, conversion-focused landing page for a SaaS startup with interactive animations and lead capture forms.",
    image: "/api/placeholder/600/400",
    url: "#",
    github: "#",
    technologies: ["React", "Tailwind CSS", "Framer Motion", "Node.js"],
    category: "web-development",
    featured: true,
    metrics: {
      conversion: "45%",
      bounce: "-30%",
      speed: "98",
    },
  },
  {
    id: 3,
    title: "Restaurant Social Media Campaign",
    description:
      "Comprehensive social media strategy that increased restaurant footfall by 200% through targeted content and ads.",
    image: "/api/placeholder/600/400",
    url: "#",
    github: "#",
    technologies: ["Instagram", "Facebook Ads", "Content Creation", "Analytics"],
    category: "social-media",
    featured: true,
    metrics: {
      reach: "50K+",
      engagement: "+300%",
      footfall: "+200%",
    },
  },
  {
    id: 4,
    title: "E-learning Platform",
    description:
      "Full-featured online learning platform with course management, video streaming, and progress tracking.",
    image: "/api/placeholder/600/400",
    url: "#",
    github: "#",
    technologies: ["React", "Node.js", "MongoDB", "Express"],
    category: "web-development",
    featured: false,
    metrics: {
      students: "1K+",
      completion: "85%",
      rating: "4.8/5",
    },
  },
  {
    id: 5,
    title: "Fashion Brand Growth Campaign",
    description:
      "Developed and executed a complete digital marketing strategy for an emerging fashion brand.",
    image: "/api/placeholder/600/400",
    url: "#",
    github: "#",
    technologies: ["Instagram", "TikTok", "Influencer Marketing", "Brand Strategy"],
    category: "social-media",
    featured: false,
    metrics: {
      followers: "+500%",
      sales: "+250%",
      brand_awareness: "+400%",
    },
  },
];

export const skills = [
  {
    category: "Frontend Development",
    items: [
      { name: "React/Next.js", level: 95 },
      { name: "JavaScript/TypeScript", level: 90 },
      { name: "Tailwind CSS", level: 92 },
      { name: "HTML5/CSS3", level: 95 },
    ],
  },
  {
    category: "Backend Development",
    items: [
      { name: "Node.js", level: 85 },
      { name: "Python", level: 80 },
      { name: "MongoDB", level: 88 },
      { name: "REST APIs", level: 90 },
    ],
  },
  {
    category: "Digital Marketing",
    items: [
      { name: "Social Media Strategy", level: 95 },
      { name: "Content Marketing", level: 90 },
      { name: "Paid Advertising", level: 88 },
      { name: "Analytics & SEO", level: 85 },
    ],
  },
  {
    category: "Tools & Platforms",
    items: [
      { name: "WordPress/WooCommerce", level: 92 },
      { name: "Facebook/Instagram Ads", level: 90 },
      { name: "Google Analytics", level: 85 },
      { name: "Figma/Adobe Creative", level: 80 },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "CEO, GreenTech Solutions",
    content:
      "Pranav delivered an outstanding e-commerce platform that exceeded our expectations. The combination of technical excellence and marketing insights made all the difference.",
    rating: 5,
    image: "/api/placeholder/60/60",
  },
  {
    id: 2,
    name: "Mike Rodriguez",
    role: "Marketing Director, FoodieHub",
    content:
      "The social media campaign Pranav created increased our customer engagement by 300%. His strategic approach to digital marketing is impressive.",
    rating: 5,
    image: "/api/placeholder/60/60",
  },
  {
    id: 3,
    name: "Emma Chen",
    role: "Founder, StyleCraft Boutique",
    content:
      "Working with Pranav was a game-changer for our business. He built our website and managed our digital marketing - results speak for themselves!",
    rating: 5,
    image: "/api/placeholder/60/60",
  },
];

export const contactInfo = {
  email: "pranavkumar431@gmail.com",
  phone: "+917004961989",
  availability: "Available for new projects",
  responseTime: "Within 24 hours",
  preferredContact: "email",
};
